import * as React from "react";
const SvgReflections = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.99984 10.8332C10.4601 10.8332 10.8332 10.4601 10.8332 9.99984C10.8332 9.5396 10.4601 9.1665 9.99984 9.1665C9.5396 9.1665 9.1665 9.5396 9.1665 9.99984C9.1665 10.4601 9.5396 10.8332 9.99984 10.8332Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.8335 16.8335C18.5335 15.1418 16.8502 10.7001 13.0835 6.91682C9.30015 3.15015 4.85848 1.46682 3.16682 3.16682C1.46682 4.85848 3.15015 9.30015 6.91682 13.0835C10.7001 16.8502 15.1418 18.5335 16.8335 16.8335Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.0835 13.0835C16.8502 9.30015 18.5335 4.85848 16.8335 3.16682C15.1418 1.46682 10.7001 3.15015 6.91682 6.91682C3.15015 10.7001 1.46682 15.1418 3.16682 16.8335C4.85848 18.5335 9.30015 16.8502 13.0835 13.0835Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgReflections;
